// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2215":"01db7e4b","9721":"79ff2c8e"}[chunkId] || chunkId) + "." + {"2215":"ac33731e1808a9ee","2708":"fe7afe06d9204b4d","3125":"f06aee8f4c8f5468","5419":"0b87fd0dfaf9abce","6434":"b0d733057384716c","7058":"31f7f1da40a73880","9721":"e0f6d00c1815a476"}[chunkId] + ".js";
};